import React, { useContext, useEffect, useState } from 'react'
import FormPhone from '../FormPhone'
import FormEmail from '../FormEmail'
import { AdCommonEvents, callPixelEvent, ContextApp } from '@monorepo/service'
import { useLogin } from '@monorepo/api'

declare const window: Window &
  typeof globalThis & {
    updateContent?: any
  }

const Layout = () => {
  const { isCdaCheck, isCdaBalancerInfoLoading, cdaBalancerInfo } = useContext(ContextApp)
  const [mode, setMode] = useState<'phone' | 'email'>('phone')
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const [initialStyle, setInitialStyle] = useState<React.CSSProperties>()
  const { origin, redirectToLoginPage } = useLogin({
    geo: 'KZ',
    isBalancerInfoLoading: isCdaBalancerInfoLoading,
    balancerInfo: cdaBalancerInfo,
  })

  useEffect(() => {
    if (isCdaCheck) {
      callPixelEvent({ event: AdCommonEvents.Visit })
      callPixelEvent({ event: AdCommonEvents.LandingPageView })
      callPixelEvent({ event: AdCommonEvents.RegNotFinished })
    }
  }, [isCdaCheck])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const regType = params.get('reg_type')
    if (regType === 'email' || regType === 'phone') {
      setMode(regType)
    }

    const flexDir = regType === 'phone' ? 'row-reverse' : undefined
    setInitialStyle({
      flexDirection: flexDir,
    })

    const script = document.createElement('script')
    script.type = 'module'
    script.src = '/assets/js/index.js'
    script.crossOrigin = ''
    script.onload = () => {
      window.updateContent?.()
      setScriptLoaded(true)
    }
    document.head.appendChild(script)
    return () => void document.head.removeChild(script)
  }, [])

  useEffect(() => {
    if (scriptLoaded) {
      window.updateContent?.()
    }
  }, [mode, scriptLoaded])

  return (
    <>
      <header className="header">
        <nav className="nav isHidden" id="nav">
          <div className="nav__logo">
            <img src="./assets/img/logo.svg" alt="BoostWin" className="estop" />
          </div>

          <div className="nav__titleWrap d-none d-xl-flex">
            <div className="nav__title">
              <span data-i18n="global.title-1">К сожалению вы ничего</span>
              <span data-i18n="global.title-2">не выиграли</span>
            </div>
            <div className="hero__subtitle">
              <span data-i18n="global.subtitle">количество попыток</span>{' '}
              <span className="attempts">3</span>
            </div>
          </div>

          <div className="nav__inner flex flex--center">
            <div className="nav__btn">
              <a
                className="button"
                data-cy="login-button"
                data-origin={origin}
                data-i18n="global.login"
                onClick={redirectToLoginPage}
              >
                Логин
              </a>
            </div>

            <div className="nav__languages">
              <div className="langSelector" id="languageSwitcher">
                <div className="selected">
                  <img src="./flags/ru.svg" alt="ru" />
                  <span>ru</span>
                  <div className="selected-icon">
                    <img
                      src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='12'%20height='12'%20viewBox='0%200%2012%2012'%20fill='none'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M1.10823%203.68568C1.44296%203.34306%201.98568%203.34306%202.32041%203.68568L6.00004%207.49235L9.67966%203.68568C10.0144%203.34306%2010.5571%203.34306%2010.8918%203.68567C11.2266%204.02829%2011.2266%204.58379%2010.8918%204.92641L6.90917%209.04326C6.40707%209.55719%205.593%209.55719%205.0909%209.04326L1.10823%204.92641C0.773494%204.58379%200.773494%204.02829%201.10823%203.68568Z'%20fill='white'/%3e%3c/svg%3e"
                      alt="Win"
                    />
                  </div>
                </div>
                <ul className="dropdown-list"></ul>
              </div>
            </div>
          </div>
        </nav>
      </header>

      <main className="main">
        <section className="hero">
          <div className="hero__container container">
            <div className="hero__title d-xl-none">
              <span data-i18n="global.title-1">Запускай игру</span>
              <br />
              <span data-i18n="global.title-2">и получай бонус!</span>
            </div>
            <div className="hero__subtitle d-xl-none">
              <span data-i18n="global.subtitle">количество попыток:</span>{' '}
              <span className="attempts">3</span>
            </div>

            <div className="ejWheel">
              <div className="ejWheel__inner">
                <img
                  src="./assets/img/effect-back.webp"
                  alt="Win"
                  className="estop absolute ejWheel__back-effect "
                />
                <img
                  src="./assets/img/wheel-center.png"
                  alt="Win"
                  className="estop ejWheel__center wheelShakeSmall"
                />
                <img
                  src="./assets/img/wheel-outer.webp"
                  alt="Win"
                  className="estop ejWheel__outer"
                />
                <img
                  src="data:image/svg+xml,%3csvg%20width='35'%20height='35'%20viewBox='0%200%2035%2035'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M32.5056%2026.4866C25.9626%2037.8194%209.60508%2037.8194%203.06209%2026.4866C-3.4809%2015.1538%204.69784%200.987763%2017.7838%200.987764C30.8698%200.987765%2039.0486%2015.1538%2032.5056%2026.4866Z'%20fill='url(%23paint0_linear_1035_17932)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1035_17932'%20x1='-0.760758'%20y1='74.2388'%20x2='57.3456'%20y2='-20.6476'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.315'%20stop-color='%23E29E26'/%3e%3cstop%20offset='0.74'%20stop-color='%23F8F595'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e"
                  alt="Win"
                  className="estop ejWheel__arrow wheelShakeSmallArrow"
                />
                <img
                  src="data:image/svg+xml,%3csvg%20width='44'%20height='38'%20viewBox='0%200%2044%2038'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22.0954%2037.0317L0.715278%200.000225144L43.4756%200.000228882L22.0954%2037.0317Z'%20fill='url(%23paint0_linear_1035_17922)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1035_17922'%20x1='8.62942'%20y1='53.1909'%20x2='50.8229'%20y2='-15.7101'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.315'%20stop-color='%23E29E26'/%3e%3cstop%20offset='0.74'%20stop-color='%23F8F595'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e"
                  alt="Win"
                  className="estop ejWheel__pointer "
                />
              </div>

              <div className="ejWheel__buttonWrap" data-detect-off-screen>
                <span className="ejWheel__button setPulseAnimation" data-i18n="global.action">
                  играть
                </span>
              </div>
            </div>
          </div>
        </section>

        <picture>
          <source media="(min-width: 1200px)" srcSet="./assets/img/girl-13.webp" />
          <source media="(min-width: 768px)" srcSet="./assets/img/girl-1.webp" />
          <img src="./assets/img/girl-12.webp" alt="Win" className="estop absolute main__girl-1" />
        </picture>

        <picture>
          <source media="(min-width: 1200px)" srcSet="./assets/img/girl-23.webp" />
          <source media="(min-width: 768px)" srcSet="./assets/img/girl-2.webp" />
          <img src="./assets/img/girl-22.webp" alt="Win" className="estop absolute main__girl-2" />
        </picture>
      </main>

      <div className="ejModal " id="modal-1">
        <div className="ejModal__inner">
          <div className="modalStep" id="modalStep-1">
            <div className="modalStep__title">
              <span data-i18n="global.title-2_1">К сожалению вы ничего</span>
              <br />
              <span data-i18n="global.title-2_2">не выиграли</span>
            </div>
            <div className="modalStep__button setPulseAnimation" data-i18n="global.action-2">
              Попробуй еще раз
            </div>
          </div>
        </div>
      </div>

      <div className="ejModal " id="modal-2">
        <div className="ejModal__inner">
          <div className="modalStep" id="modalStep-2">
            <div className="modalStep__title modalStep__title--big" data-i18n="global.title-3">
              Ваш первый бонус!
            </div>
            <div className="modalStep__content">
              <span data-i18n="form.win-line-4">+180 FS</span>
            </div>
            <div className="modalStep__button setPulseAnimation" data-i18n="global.action-3">
              крутить еще
            </div>
          </div>
        </div>
      </div>

      <div className="ejModal  " id="modal-3">
        <div className="ejModal__inner ejModal__inner--smallPadding">
          <div className="ejForm" id="ejForm">
            {/* <div className="ejForm__head">
              <span data-i18n="form.title-1">Регистрируйся,</span>
              <span data-i18n="form.title-2">и забирай бонус!</span>
            </div> */}
            <div className="ejForm__title">
              <div data-i18n="form.win-line-2" className="tSmall">
                Ваш бонус на первый депозит:
              </div>
              <div data-i18n="form.win-line-1">1 500 000 ₸</div>
              <div data-i18n="form.win-line-3">+ 180 FS !</div>
            </div>
            <div className="ejForm__content">
              <div className="ejForm__toggle" style={initialStyle}>
                <div
                  className={mode === 'email' ? 'active' : ''}
                  onClick={() => setMode('email')}
                  data-i18n="form.toggle.email"
                >
                  Почта
                </div>
                <div
                  className={mode === 'phone' ? 'active' : ''}
                  onClick={() => setMode('phone')}
                  data-i18n="form.toggle.phone"
                >
                  Телефон
                </div>
              </div>
              {mode === 'phone' ? <FormPhone /> : <FormEmail />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Layout
